import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { Button } from "./ui/button";
import { SlidersHorizontal, X } from "lucide-react";

const MAKES = ["Alle", "Audi", "BMW", "Mercedes-Benz", "Porsche", "Tesla", "Volkswagen"];
const FUELS = ["Alle", "Benzin", "Diesel", "Elektro", "Hybrid"];
const TRANSMISSIONS = ["Alle", "Automatik", "Manuell", "DSG"];
const SORT = [
  { v: "newest", l: "Neueste zuerst" },
  { v: "price_asc", l: "Preis aufsteigend" },
  { v: "price_desc", l: "Preis absteigend" },
  { v: "year_desc", l: "Baujahr neu" },
  { v: "mileage_asc", l: "Kilometer aufsteigend" },
];

const defaultFilters = {
  make: "Alle",
  model: "",
  price_min: "",
  price_max: "",
  mileage_max: "",
  year_min: "",
  fuel: "Alle",
  transmission: "Alle",
  sort: "newest",
};

const VehicleFilters = ({ value, onChange, onReset }) => {
  const [open, setOpen] = React.useState(false);
  const v = { ...defaultFilters, ...value };
  const set = (k, val) => onChange({ ...v, [k]: val });

  const Body = (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      <FilterSelect label="Marke" testId="filter-make" value={v.make} onValueChange={(x) => set("make", x)} options={MAKES} />
      <FilterInput label="Modell" testId="filter-model" placeholder="z.B. 530d" value={v.model} onChange={(e) => set("model", e.target.value)} />
      <FilterSelect label="Kraftstoff" testId="filter-fuel" value={v.fuel} onValueChange={(x) => set("fuel", x)} options={FUELS} />
      <FilterSelect label="Getriebe" testId="filter-transmission" value={v.transmission} onValueChange={(x) => set("transmission", x)} options={TRANSMISSIONS} />
      <FilterInput label="Preis von €" testId="filter-price-min" type="number" placeholder="0" value={v.price_min} onChange={(e) => set("price_min", e.target.value)} />
      <FilterInput label="Preis bis €" testId="filter-price-max" type="number" placeholder="100000" value={v.price_max} onChange={(e) => set("price_max", e.target.value)} />
      <FilterInput label="Max. Kilometerstand" testId="filter-mileage-max" type="number" placeholder="200000" value={v.mileage_max} onChange={(e) => set("mileage_max", e.target.value)} />
      <FilterInput label="Baujahr ab" testId="filter-year-min" type="number" placeholder="2015" value={v.year_min} onChange={(e) => set("year_min", e.target.value)} />
      <div>
        <Label className="text-[11px] uppercase tracking-widest text-zinc-400 mb-2 block">Sortierung</Label>
        <Select value={v.sort} onValueChange={(x) => set("sort", x)}>
          <SelectTrigger data-testid="filter-sort" className="bg-[#1A1A22] border-white/10 text-white">
            <SelectValue />
          </SelectTrigger>
          <SelectContent className="bg-[#232330] border-white/10 text-white">
            {SORT.map((s) => (<SelectItem key={s.v} value={s.v} className="focus:bg-white/10 focus:text-white">{s.l}</SelectItem>))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );

  return (
    <div className="bg-[#2E2E3C] border border-silver-soft rounded-2xl p-5 lg:p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-display font-semibold text-white text-lg flex items-center gap-2">
          <SlidersHorizontal className="w-4 h-4 text-[var(--na-red)]" /> Filter
        </h3>
        <div className="flex gap-2 items-center">
          <button
            onClick={onReset}
            data-testid="filter-reset-button"
            className="text-xs uppercase tracking-widest text-zinc-400 hover:text-white px-3 py-1.5 border border-white/10 rounded-xl inline-flex items-center gap-1.5"
          >
            <X className="w-3 h-3" /> Zurücksetzen
          </button>
          <button
            onClick={() => setOpen((x) => !x)}
            data-testid="filter-toggle-mobile"
            className="lg:hidden text-xs uppercase tracking-widest text-white px-3 py-1.5 bg-white/5 border border-white/10 rounded-xl"
          >
            {open ? "Schließen" : "Anzeigen"}
          </button>
        </div>
      </div>
      <div className={`${open ? "block" : "hidden"} lg:block`}>{Body}</div>
    </div>
  );
};

const FilterSelect = ({ label, value, onValueChange, options, testId }) => (
  <div>
    <Label className="text-[11px] uppercase tracking-widest text-zinc-400 mb-2 block">{label}</Label>
    <Select value={value} onValueChange={onValueChange}>
      <SelectTrigger data-testid={testId} className="bg-[#1A1A22] border-white/10 text-white">
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="bg-[#232330] border-white/10 text-white max-h-72">
        {options.map((o) => (
          <SelectItem key={o} value={o} className="focus:bg-white/10 focus:text-white">{o}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  </div>
);

const FilterInput = ({ label, testId, ...rest }) => (
  <div>
    <Label className="text-[11px] uppercase tracking-widest text-zinc-400 mb-2 block">{label}</Label>
    <Input data-testid={testId} {...rest} className="bg-[#1A1A22] border-white/10 text-white placeholder:text-zinc-600 focus-visible:ring-[var(--na-red)] focus-visible:border-[var(--na-red)]" />
  </div>
);

export { defaultFilters };
export default VehicleFilters;
